import { Skeleton } from "@mui/material";
import "react-swipeable-list/dist/styles.css";
import {
    CommentContainerGrid,
    CommentContentContainerGrid,
    CommentContentPaper,
} from "./Comment.styles";
import React from "react";

export default function SkeletonComment() {
    return (
        <div>
            <CommentContainerGrid direction="row">
                <div
                    style={{
                        width: "32px",
                        height: "32px",
                        marginRight: "8px",
                    }}
                >
                    <Skeleton
                        animation="wave"
                        variant="circular"
                        width={"32px"}
                        height={"32px"}
                    />
                </div>
                <CommentContentContainerGrid style={{ width: "100%" }}>
                    <CommentContentPaper>
                        <Skeleton animation="wave" height={20} width="75%" />
                        <Skeleton animation="wave" height={100} width="100%" />
                    </CommentContentPaper>
                </CommentContentContainerGrid>
            </CommentContainerGrid>
        </div>
    );
}
